module.exports = "/assets/8a4c6101a897be6322f9d0500e58f1bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OB.png
// module id = 2798
// module chunks = 0